import { useTranslation } from 'react-i18next'
import React from 'react'

import { FlexCol } from '../structure/FlexGrid'
import { SmallText, Text } from '../presentation/Text'
import { useTableActions, useTableState } from './MultiSelectTableContext'
import FooterModal, { FooterModalLink } from '../structure/FooterModal'
import Link from '../actions/Link'
import { COLORS } from '@btime/constants'

const MultiSelectMenu = ({ t, list, count, children, disableForceSelection, options = [], loading }) => {
  const { t: _t } = useTranslation()
  const { selecteds, isForcingSelection } = useTableState()
  const { clearSelection, toggleForceSelection } = useTableActions()
  const canForceSelectAll = !disableForceSelection && count > selecteds.length
  const finalCount = isForcingSelection ? count : selecteds.length
  const linkColor = isForcingSelection ? COLORS.red : COLORS.blue

  return (
    <FooterModal
      open={isForcingSelection || selecteds.length}
      onClose={clearSelection}
      bgColor={COLORS.dark2}
      loading={loading}
    >
      <FlexCol flex={1}>
        <Text size="h5" color={COLORS.white} noWrap>
          {finalCount} items selecionados
        </Text>
        {canForceSelectAll && (
          <SmallText color={COLORS.white} bold>
            {isForcingSelection && 'Forçando seleção de todos itens. '}
            <Link color={linkColor} onClick={toggleForceSelection}>
              Clique aqui
            </Link>{' '}
            para {isForcingSelection ? `desativar seleção forçada` : `selecionar todos ${count} itens`}.
          </SmallText>
        )}
      </FlexCol>
      {children}
      {options.map(({ label, value, color, ...props }) => (
        <FooterModalLink key={value + label} color={color || COLORS.white} label={label || value} t={t} {...props} />
      ))}
    </FooterModal>
  )
}

export default MultiSelectMenu
